import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './LocationOverview.module.scss';

const baseClass = 'location-overview';

type Props = {
  title: string;
  description: string;
  className?: string;
};

type StatCardProps = {
  value: string | number;
  label: string;
  description: string;
  color: 'green' | 'yellow' | 'purple';
};

const stats: StatCardProps[] = [
  {
    value: '200',
    label: 'Countries and Territories',
    description: 'Access data from virtually every corner of the world.',
    color: 'green',
  },
  {
    value: '300',
    label: 'Million+ Businesses',
    description: 'Gain insights into businesses worldwide.',
    color: 'yellow',
  },
  {
    value: '3',
    label: 'Directly Sourced Data',
    description:
      'Our data is collected directly from local government registries, providing unmatched accuracy and authenticity.',
    color: 'purple',
  },
];

const StatCard = ({ value, label, description, color }: StatCardProps) => (
  <div className={cn(styles[`${baseClass}-card`], styles[`${baseClass}-${color}`])}>
    <div className={styles[`${baseClass}-inner`]}>
      <h3 className={styles[`${baseClass}-value`]}>{value}</h3>
      <p className={styles[`${baseClass}-label`]}>{label}</p>
    </div>

    <span className={styles[`${baseClass}-description`]}>{description}</span>
  </div>
);

export const LocationOverview = ({ title, description, className }: Props) => {
  return (
    <section className={cn(styles[`${baseClass}-wrapper`], className)}>
      <div className={styles[`${baseClass}-container`]}>
        <TitleBlock title={title} description={description} />

        <div className={styles[`${baseClass}-cards`]}>
          {stats.map((stat, idx) => (
            <StatCard key={idx} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
};
